<div class="modal-container"
    [ngClass]="[modalVisible ? 'on': '', modalData?.modal_type ? modalData?.modal_type : '', modalData?.full_screen ? 'full-screen' : '', modalData?.modal_type === 'medicine' ? modalData?.medicine : '']">
    <div class="cover" [ngClass]="{'on': modalVisible && !transitionOut}"></div>

    <div class="inner" [ngClass]="{'ovh': hideInner}">
        <div class="modal" [ngClass]="{'on': modalVisible && !transitionOut, 'hide': animating}">
            <div class="header" *ngIf="modalData?.full_screen">
                <!-- <h2 [innerHTML]="modalData?.title"></h2> -->
            </div>

            <div *ngIf="!modalData?.hide_close" class="modal-close close-x"
                [ngClass]="{'offset': modalData?.close_btn_offset}" (click)="closeModal()">
                <div class="x"></div>
            </div>




            <ng-container *ngIf="modalData?.modal_type === 'welcome'">
                <app-welcome></app-welcome>
            </ng-container>


            <ng-container *ngIf="modalData?.modal_type === 'thankyou'">
                <app-thankyou></app-thankyou>
            </ng-container>


            <ng-container *ngIf="modalData?.modal_type === 'media'">
                <app-media></app-media>
            </ng-container>


            <ng-container *ngIf="modalData?.modal_type === 'leaving'">
                <app-leaving></app-leaving>
            </ng-container>


            <ng-container *ngIf="modalData?.modal_type === 'video-player'">
                <app-video-player [data]="modalData" [path]="path"></app-video-player>
            </ng-container>


            <ng-container *ngIf="modalData?.modal_type === 'medicine'">
                <app-medicine [data]="modalData"></app-medicine>
            </ng-container>


            <ng-container *ngIf="modalData?.modal_type === 'iframe'">
                <iframe [src]="iframeSource" class="iframe"></iframe>
            </ng-container>


            <ng-container *ngIf="modalData?.modal_type === 'connect'">
                <app-connect></app-connect>
            </ng-container>


            <ng-container *ngIf="modalData?.modal_type === 'pdf'">
                <ng2-pdfjs-viewer [pdfSrc]="pdfSrc" [download]="false" [print]="false" [viewBookmark]="false"
                    [openFile]="false" [find]="false" viewerId="pdf-viewer">
                </ng2-pdfjs-viewer>
            </ng-container>
        </div>
    </div>
</div>